<template>
  <b-modal ref="formModal" :hideFooter="true" size="lg" title="Create new client" @hidden="onHide" :noCloseOnBackdrop="true">
    <div class="row">
      <div class="col-12 m-form m-form--state">

        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'name' }">
          <label for="name">Name</label>
          <input type="text" id="name" v-model="client.name" class="form-control" placeholder="Name">
        </div>

        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'currency_id' }">
          <label for="currency_id">Invoice currency</label>
          <select id="currency_id" v-model="client.currency_id" class="form-control">
            <option :value="currency.id" v-for="currency in currencies">{{ currency.name }}</option>
          </select>
        </div>

        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'price_per_hour' }">
          <label for="price_per_hour">Price per hour <b>in EUR</b></label>
          <input type="text" id="price_per_hour" v-model="client.price_per_hour" class="form-control" placeholder="Price per hour">
        </div>

        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'company_name' }">
          <label for="company_name">Company name</label>
          <input type="text" id="company_name" v-model="client.company_name" class="form-control" placeholder="Company name">
        </div>

        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'address' }">
          <label for="address">Address</label>
          <input type="text" id="address" v-model="client.address" class="form-control" placeholder="Address">
        </div>

        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'vat' }">
          <label for="vat">Vat</label>
          <input type="text" id="vat" v-model="client.vat" class="form-control" placeholder="Vat">
        </div>

        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'email' }">
          <label for="vat">Email</label>
          <div class="row mt-2" v-if="emails" v-for="email, index in emails">
            <div class="col">
              <input type="text" v-model="email.email" class="form-control email" placeholder="Email">
            </div>
            <div class="col-auto">
              <div class="btn btn-danger btn-sm mt-2" @click="emails.splice(index, 1)">
                <i class="fa fa-minus"></i>
              </div>
            </div>
          </div>
          <div class="btn btn-info btn-sm mt-2" @click="emails.push({'email' : null})">
            <i class="fa fa-plus"></i>
          </div>
        </div>

        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'payment_term' }">
          <label for="payment_term">Payment term (days)</label>
          <input id="payment_term" type="number" class="form-control" v-model="client.payment_term">
        </div>

        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'manager_id' }">
          <label for="manager">Manager</label>
          <select id="manager" v-model="client.manager_id" class="form-control">
            <option value="null" disabled>Please select</option>
            <option :value="manager.id" v-for="manager in managers">{{ manager.name }}</option>
          </select>
        </div>

        <h3>Primary contacts</h3>

        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'contacts.name' }">
          <label for="contacts.name">Name</label>
          <input type="text" id="contacts.name" v-model="client.contacts.name" class="form-control" placeholder="Name">
        </div>
        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'contacts.last_name' }">
          <label for="contacts.last_name">Last Name</label>
          <input type="text" id="contacts.last_name" v-model="client.contacts.last_name" class="form-control" placeholder="Last Name">
        </div>
        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'contacts.job_title' }">
          <label for="contacts.job_title">Job title</label>
          <input type="text" id="contacts.job_title" v-model="client.contacts.job_title" class="form-control" placeholder="Job title">
        </div>
        <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'contacts.phone_number' }">
          <label for="contacts.phone_number">Phone number</label>
          <input type="text" id="contacts.phone_number" v-model="client.contacts.phone_number" class="form-control" placeholder="Phone number">
        </div>

        <div class="text-center mt-3">
          <div class="btn btn-brand mr-1" @click="submit()">{{ isEdit ? 'Update' : 'Create' }}</div>
          <div class="btn btn-metal" @click="hide()">Cancel</div>
        </div>

      </div>
    </div>
  </b-modal>
</template>
<script>
  import bModal from 'bootstrap-vue/es/components/modal/modal'

  export default {
    components: {
      'b-modal': bModal,
    },
    created() {
      this.axios.get('/currencies').then(response => {
        this.currencies = response.data
      })
      this.axios.get('/managers').then(response => {
        this.managers = response.data.data
      })

      this.loadClient();
    },
    data() {
      return {
        client: {},
        currencies: [],
        errors: false,
        managers: [],
        emails: [
          {email: null}
        ],
      }
    },
    computed: {
      isEdit() {
        return this.client.id
      },
    },
    methods: {
      loadClient() {
        this.client = {
          id: null,
          name: null,
          contacts:{
            name: null,
            last_name: null,
            job_title: null,
            phone_number: null,
          },
          currency_id: 1,
          email: null,
          manager_id: null,
          payment_term: null,
        }
      },
      onHide() {
        this.errors = false
        this.emails = [{email: null}]
        this.loadClient();
      },
      hide() {
        this.emails = []
        this.$refs.formModal.hide();
      },
      create() {
        this.$refs.formModal.show();
      },
      edit(client) {
        Object.assign(this.client, client)

        if (client.email && client.email.length > 0) {
          this.emails = []
        }

        _.each(client.email, e => {
          this.emails.push({'email' : e})
        })

        this.$refs.formModal.show();
      },
      submit() {
        let emails = []
        _.each(this.emails, e => {
          if (e.email) {
            emails.push(e.email)
          }
        })
        this.client.email = emails

        if (this.isEdit) {
          this.update()
        } else {
          this.store()
        }
      },
      store() {
        this.axios.post('/clients', this.client).then(response => {
          if (response.status === 201) {
            this.$emit('clientCreated', response.data.data)
            this.$root.$emit('create-success', response.data.data)
            this.hide()
          }
        }).catch(err => {
          if (err.response.data && err.response.data.errors) {
            this.errors = err.response.data.errors
          }
        })
      },
      update() {
        this.axios.put('/clients/' + this.client.id, this.client).then(response => {
          if (response.status === 202) {
            this.$emit('clientUpdated', response.data.data)
            this.$root.$emit('update-success', response.data.data)
            this.hide()
          }
        }).catch(error => {
        })
      },
//      onHidding($event) {
//        $event.preventDefault()
//        console.log($event)
//      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/clients/ClientForm.vue